import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterService } from 'src/app/auth/services/register.service';
import { CompanyApprovalService } from '../../../services/company-approval-service';
import { CompanyService } from '../../../../users/services/company.service';
import { IStateCount } from 'src/app/auth/models/register.model';
import { DatePipe } from '@angular/common';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { SharedService } from 'src/app/shared/services';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { DialogService } from 'primeng/dynamicdialog';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';

@Component({
  selector: 'app-company-approval-view',
  templateUrl: './company-approval-view.component.html',
  styleUrls: ['./company-approval-view.component.css'],
  providers: [DialogService]
})
export class CompanyApprovalViewComponent implements OnInit {
  paragraph : string="Sundar Aruna : Director of DevLabs";
  usersList:any;
  adminUserProfileId;
  vendorName;
  vendorShortName;
  vendorEmailId;
  addressLine1 ="USA";
  addressLine2 ="Texas";
  webAddress;
  taxIdNumber;
  city;
  state;
  zipCode;
  companysKeyCapabilities;
  companyEstablishment;
  businessCertifications ="";
  awardsAndCertifications;
  corporateHistory;
  officeCity;
  contactName;
  phone;
  vendorPhoneNumber;
  vendorPhoneExtNumber;
  faxNumber;
  address;
  ownerName;
  ownerTitle;
  ownerEmail;
  ownerPhone;
  recruitingName;
  recruitingTitle;
  recruitingEmail;
  recruitingPhone;
  financialName;
  financialTitle;
  financialEmail;
  financialPhone;
  accountingName;
  accountingTitle;
  accountingEmail;
  accountingPhone;
  leadership;
  firstName;
  lastName;
  refClientName;
  refContactName;
  refContactTitle;
  refContactEmail;
  refContactPhone;
  refIndustry;
  refDuration;
  refServices;
  adminEmailId;
  phoneNumber;
  mainContactPhone;
  extNumber;
  isEVerifyRegistered;
  isOfferACAAct;
  onshoreFields;
  offshoreFields;
  referenceFields;
  companyRevenueLastYear;
  companyRevenue2YearsBefore;
  companyRevenue3YearsBefore;
  lastYear:any;
  last2YearBefore:any;
  last3YearBefore:any;
  lastYearValue:any;
  last2YearBeforeValue:any;
  last3YearBeforeValue:any;
  companyW2EmployeeCount;
  noofC2CConsultant;
  isOPTStudents;
  isSupportTNVisa;
  accountingAlternatePhone;
  financialAlternatePhone;
  ownerAlternatePhone;
  recruitingAlternatePhone;
  noofW2Employees;
  stateCount: IStateCount[]=[];
  alabama=0;
  alaska=0;
  arizona=0;
  arkansas=0;
  california=0;
  colorado=0;
  connecticut=0;
  delaware=0;
  florida=0;
  georgia=0;
  hawaii=0;
  idaho=0;
  illinois=0;
  indiana=0;
  iowa=0;
  kansas=0;
  kentucky=0;
  louisiana=0;
  maine=0;
  maryland=0;
  massachusetts=0;
  michigan=0;
  minnesota=0;
  mississippi=0;
  missouri=0;
  montana=0;
  nebraska=0;
  nevada=0;
  newHampshire=0;
  newJersey=0;
  newMexico=0;
  newYork=0;
  northCarolina=0;
  northDakota=0;
  ohio=0;
  oklahoma=0;
  oregon=0;
  pennsylvania=0;
  rhodeIsland=0;
  southCarolina=0;
  southDakota=0;
  tennessee=0;
  texas=0;
  utah=0;
  vermont=0;
  virginia=0;
  washington=0;
  westVirginia=0;
  wisconsin=0;
  wyoming=0;
  showPreview:boolean = false;
  showW9FormFile:boolean=false;
  pdfSrc;
  w9FormFileName;
  DDpdfSrc;
  showDDPreview:boolean = false;
  ddAuthorizationFileName;
  showDDAuthorizationFile;
  MSApdfSrc;
  showMSAPreview:boolean = false;
  msaFileName;
  msaDocumentFileName
  showMsaFile;
  InsurancepdfSrc;
  showInsurancePreview:boolean = false;
  insuranceFileName:string;
  showInsuranceFile;
  comments;
  clientNames ="";
  glEffDate;
  glExpDate;
  alEffDate;
  alExpDate;
  ulEffDate;
  ulExpDate;
  wcEffDate;
  wcExpDate;
  plEffDate;
  plExpDate;
  availableCandidateBench;
  numberofotpcandidates;
  technologytrain;
  noofTNVisaCandidates;
  selectedTNVisaCountries="";
  entitytype;
  paymentTerms;
  zipCodeExt;
  invoiceTerms;
  companyProfileView: any;
  stateName:string;
  selectedClientNames:string;
  vendorCategory:any;

  w9FileDocUrl: string="https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/20220117T022518072";
  ddFileDocUrl: string="https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/20220117T022518072";
  coiFileDocUrl:string="https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/20220117T022518072";
  msaFileDocUrl:string="https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/20220117T022518072";
  showCOIFilePreview:boolean=false;
  showW9FilePreview:boolean=false;
  showDDFilePreview:boolean=false;
  showMSAFilePreview:boolean=false;
  constructor(
    private companyApprovalService: CompanyApprovalService,
    private _router: Router,
    private route: ActivatedRoute,
    private registerService:RegisterService,
    private companyService:CompanyService,
    private datepipe: DatePipe,
    private sharedService:SharedService, 
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    const param = this.route.snapshot.paramMap.get('adminUserProfile');
    if (param) {
     this.adminUserProfileId = param;
    }  
    if(this.adminUserProfileId != undefined)
    {
      this.companyApprovalService.viewCompanyProfile(this.adminUserProfileId).subscribe((data:any) => {
        this.stateName = data[0].selectedState.stateName;
        if(data[0].onshoreFields.length>0)
        {  
          this.onshoreFields = data[0].onshoreFields;
        }
        if(data[0].offshoreFields.length>0)
        {  
          this.offshoreFields = data[0].offshoreFields;
        }
        if(data[0].referenceFields.length>0)
        { 
          this.referenceFields = data[0].referenceFields;
        }
        this.registerService.GetSelectedBusinessCertifications(data[0].businessCertificationIds).subscribe((businessCertIds:any) => {
          console.log(businessCertIds);
          for(var i=0; i<businessCertIds.length;i++)
          {
            if(this.businessCertifications=='')
            {
              this.businessCertifications = this.businessCertifications+ businessCertIds[i].description;
            }
            else
            {
              this.businessCertifications = this.businessCertifications+',' + businessCertIds[i].description;
            }
          }
         }),
         this.registerService.GetSelectedClientIds(data[0].clientIds).subscribe((selectedClientIds:any) => {
          for(var i=0; i<selectedClientIds.length;i++)
          {
            if(this.clientNames=='')
            {
              this.clientNames = this.clientNames + selectedClientIds[i].companyName;
            }
            else
            {
              this.clientNames = this.clientNames +','+ selectedClientIds[i].companyName;
            }
          }
         }),
         this.registerService.getClientListForRegistration(data[0].clientIdOnRegistration).subscribe((data:any)=>{
          if(data != null || data !=undefined)
          {
             this.vendorCategory = data.description;
          }  
         }),
         this.registerService.GetSelectedCountryVisa(data[0].tnVisaCountries).subscribe((VisaCountryIds:any) => {
          for(var i=0; i<VisaCountryIds.length;i++)
          {
            if(this.selectedTNVisaCountries=='')
            {
              this.selectedTNVisaCountries = this.selectedTNVisaCountries + VisaCountryIds[i].description;
            }
            else
            {
              this.selectedTNVisaCountries = this.selectedTNVisaCountries +','+ VisaCountryIds[i].description;
            }
          }
         }),
         this.registerService.getEntityType(data[0].entityTypeId).subscribe((entitydata:any) =>{
          this.entitytype = entitydata.description;
        });
        this.companyService.getPaymentTerms(data[0].paymentTermsId).subscribe((paymentTerms:any) =>{
          this.paymentTerms = paymentTerms.description;
        });
        console.log(data);
        if(data[0].companyRevenueLastYear != null || data[0].companyRevenueLastYear != undefined)
        {
          var firstYear = data[0].companyRevenueLastYear.split("-", 2);
          this.lastYear = firstYear[0]; 
          this.lastYearValue =firstYear[1]; 
        }
        if(data[0].companyRevenue2YearsBefore != null || data[0].companyRevenue2YearsBefore != undefined)
        {
          var secondYear = data[0].companyRevenue2YearsBefore.split("-", 2); 
          this.last2YearBefore = secondYear[0];
          this.last2YearBeforeValue = secondYear[1];
        }
        if(data[0].companyRevenue3YearsBefore != null || data[0].companyRevenue3YearsBefore != undefined)
        {
          var thirdYear = data[0].companyRevenue3YearsBefore.split("-", 2); 
          this.last3YearBefore = thirdYear[0];
          this.last3YearBeforeValue = thirdYear[1];
        }
        this.stateCount= data[0].stateCount;
        for(var i=0;i<this.stateCount.length;i++)
          {
            if(this.stateCount[i].stateName == 'Alabama')
            {
              this.alabama = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Alaska')
            {
              this.alaska = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Arizona')
            {
              this.arizona = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Arkansas')
            {
              this.arkansas = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'California')
            {
              this.california = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Colorado')
            {
              this.colorado = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Connecticut')
            {
              this.connecticut = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Delaware')
            {
              this.delaware = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Florida')
            {
              this.florida = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Georgia')
            {
              this.georgia = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Alaska')
            {
              this.alaska = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Hawaii')
            {
              this.hawaii = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Idaho')
            {
              this.idaho = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Illinois')
            {
              this.illinois = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Indiana')
            {
              this.indiana = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Iowa')
            {
              this.iowa = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Kansas')
            {
              this.kansas = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Kentucky')
            {
              this.kentucky = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Louisiana')
            {
              this.louisiana = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Maine')
            {
              this.maine = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Maryland')
            {
              this.maryland = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Massachusetts')
            {
              this.massachusetts = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Michigan')
            {
              this.michigan = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Minnesota')
            {
              this.minnesota = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Mississippi')
            {
              this.mississippi = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Missouri')
            {
              this.missouri = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Montana')
            {
              this.montana = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Maryland')
            {
              this.maryland = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Nebraska')
            {
              this.nebraska = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Nevada')
            {
              this.nevada = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'New Hampshire')
            {
              this.newHampshire = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'New Jersey')
            {
              this.newJersey = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'New Mexico')
            {
              this.newMexico = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'New York')
            {
              this.newYork = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'North Carolina')
            {
              this.northCarolina = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'North Dakota')
            {
              this.northDakota = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Ohio')
            {
              this.ohio= this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Oklahoma')
            {
              this.oklahoma = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Oregon')
            {
              this.oregon = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Pennsylvania')
            {
              this.pennsylvania = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Rhode Island')
            {
              this.rhodeIsland = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'South Carolina')
            {
              this.southCarolina = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'South Dakota')
            {
              this.southDakota = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Tennessee')
            {
              this.tennessee = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Texas')
            {
              this.texas = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Utah')
            {
              this.utah = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Vermont')
            {
              this.vermont = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Virginia')
            {
              this.virginia = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Washington')
            {
              this.washington = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'West Virginia')
            {
              this.westVirginia = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Wisconsin')
            {
              this.wisconsin = this.stateCount[i].count;
            }
            else if(this.stateCount[i].stateName == 'Wyoming')
            {
              this.wyoming = this.stateCount[i].count;
            }

          }
       
        this.vendorName = data[0].vendorName,
        this.vendorEmailId = data[0].vendorEmailId,
        this.vendorShortName = data[0].vendorShortName,
        this.vendorPhoneNumber = data[0].vendorPhoneNumber,
        this.vendorPhoneExtNumber = data[0].vendorPhoneExtNumber,
        this.faxNumber = data[0].faxNumber,
        this.addressLine1 = data[0].addressLine1,
        this.addressLine2 = data[0].addressLine2,
        this.taxIdNumber = data[0].taxIdNumber,
        this.webAddress = data[0].webAddress,
        this.awardsAndCertifications = data[0].awardsAndCertifications,
        this.companysKeyCapabilities = data[0].companysKeyCapabilities,
        this.companyEstablishment = data[0].companyEstablishment,
        this.corporateHistory = data[0].corporateHistory,
        this.ownerName = data[0].ownerName,
        this.ownerEmail = data[0].ownerEmail,
        this.ownerPhone =data[0].ownerPhone,
        this.ownerTitle = data[0].ownerTitle,
        this.accountingName = data[0].accountingName,
        this.accountingEmail = data[0].accountingEmail,
        this.accountingTitle = data[0].accountingTitle,
        this.accountingPhone = data[0].accountingPhone,
        this.recruitingName = data[0].recruitingName,
        this.recruitingTitle = data[0].recruitingTitle,
        this.recruitingEmail = data[0].recruitingEmail,
        this.recruitingPhone = data[0].recruitingPhone,
        this.financialName = data[0].financialName,
        this.financialTitle = data[0].financialTitle,
        this.financialEmail = data[0].financialEmail,
        this.financialPhone = data[0].financialPhone,
        this.city = data[0].city,
        this.leadership = data[0].leadership,
        this.firstName = data[0].firstName,
        this.lastName = data[0].lastName,
        this.adminEmailId =data[0].adminEmailId,
        this.mainContactPhone = data[0].mainContactPhone,
        this.phoneNumber = data[0].phoneNumber,
        this.extNumber = data[0].extNumber,
        this.zipCode =data[0].zipCode,
        this.zipCodeExt=data[0].zipCodeExt,
        this.isEVerifyRegistered = data[0].isEVerifyRegistered,
        this.isOfferACAAct =  data[0].isOfferACAAct,
        this.glEffDate=this.datepipe.transform(data[0].glEffDate, 'MM-dd-yyyy');
        this.glExpDate=this.datepipe.transform(data[0].glExpDate, 'MM-dd-yyyy');
        this.alEffDate=this.datepipe.transform(data[0].alEffDate, 'MM-dd-yyyy');
        this.alExpDate=this.datepipe.transform(data[0].alExpDate, 'MM-dd-yyyy');
        this.ulEffDate=this.datepipe.transform(data[0].ulEffDate, 'MM-dd-yyyy');
        this.ulExpDate=this.datepipe.transform(data[0].ulExpDate, 'MM-dd-yyyy');
        this.wcEffDate=this.datepipe.transform(data[0].wcEffDate, 'MM-dd-yyyy');
        this.wcExpDate=this.datepipe.transform(data[0].wcExpDate, 'MM-dd-yyyy');
        this.plEffDate=this.datepipe.transform(data[0].plEffDate, 'MM-dd-yyyy');
        this.plExpDate=this.datepipe.transform(data[0].plExpDate, 'MM-dd-yyyy');
        this.companyRevenueLastYear =this.lastYearValue;
        this.companyRevenue2YearsBefore = this.last2YearBeforeValue;
        this.companyRevenue3YearsBefore = this.last3YearBeforeValue;
        this.companyW2EmployeeCount =data[0].companyW2EmployeeCount;
        this.noofC2CConsultant =data[0].noofC2CConsultant;
        this.isOPTStudents =data[0].isOPTStudents;
        this.isSupportTNVisa =data[0].isSupportTNVisa;
        this.availableCandidateBench=data[0].availableCandidateBench;
        this.ownerAlternatePhone = data[0].ownerAlternatePhone;
        this.recruitingAlternatePhone = data[0].recruitingAlternatePhone;
        this.financialAlternatePhone = data[0].financialAlternatePhone;
        this.accountingAlternatePhone = data[0].accountingAlternatePhone;
        this.noofW2Employees=data[0].noofW2Employees;
        this.numberofotpcandidates=data[0].noofOPTCandidatesAvailable;
        this.technologytrain=data[0].optTechnologyTrain;
        this.noofTNVisaCandidates=data[0].noofTNVisaCandidates;
        this.comments=data[0].comments;
        this.invoiceTerms=data[0].invoiceTerms,
        this.loadcompanysKeyCapabilities(this.companysKeyCapabilities);
        this.loadcorporateHistory(this.corporateHistory);
        this.loadawardsAndCertifications(this.awardsAndCertifications);
        this.loadavailableCandidateBench(this.availableCandidateBench);
        this.loadleadership(this.leadership);
        if(data[0].w9FormFileUrl!=null && data[0].w9FormFileUrl!='')
        {
          this.w9FormFileName=data[0].w9FormFileUrl;
          this.showW9FormFile=true;
          this.getW9FormFile();
        }
        if(data[0].ddAuthorizationFileUrl != null && data[0].ddAuthorizationFileUrl != '')
        {
          this.ddAuthorizationFileName=data[0].ddAuthorizationFileUrl;
          this.showDDAuthorizationFile=true;
          this.getDDAuthorizationFile();
        }
        if(data[0].msaFileUrl != null && data[0].msaFileUrl != '')
        {
          this.msaFileName=data[0].msaFileUrl;
          this.msaDocumentFileName =data[0].msaDocumentFileName;
          this.showMsaFile=true;
          this.getMSAFile();
        }
        if(data[0].insuranceFileUrl != null && data[0].insuranceFileUrl != '')
        {
          this.insuranceFileName=data[0].insuranceFileUrl;
          this.showInsuranceFile=true;
          this.getInsuranceFile();
        }
      });
    }
    //this.getClientNamesForView();
    this.getCompanyUsersList();
  }

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }

  backToCompanyApprovalSearch()
  {
    this._router.navigate(['/admin/vendor-approval-search']);
  }

  getCompanyUsersList(){
    this.companyService.getCompanyProfileViewByUserProfileId(this.adminUserProfileId).subscribe(data =>{
      this.companyProfileView = data[0];
      this.usersList = data[0].usersList;
    },
    error=> {
      console.log(error);
    })
  }

  getW9FormFile() {
    /*this.registerService.GetW9FormUrl(this.w9FormFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
       reader.readAsArrayBuffer(blob); 
       reader.addEventListener("load", () => {
        this.pdfSrc = reader.result;
     }, false);
  
    }, error => {
      console.log(error);
    });*/

    this.w9FileDocUrl=VMSConstants.registrationDocumentBaseUrl+this.w9FormFileName;
  }
  
  getDDAuthorizationFile() {
    /*this.registerService.GetDDAuthorizationFileUrl(this.ddAuthorizationFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
       reader.readAsArrayBuffer(blob); 
       reader.addEventListener("load", () => {
        this.DDpdfSrc = reader.result;
     }, false);
  
    }, error => {
      console.log(error);
    });*/

    this.ddFileDocUrl=VMSConstants.registrationDocumentBaseUrl+this.ddAuthorizationFileName;
  }
  
  getMSAFile() {
    /*this.registerService.GetMSAFileUrl(this.msaFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
       reader.readAsArrayBuffer(blob); 
       reader.addEventListener("load", () => {
        this.MSApdfSrc = reader.result;
     }, false);
  
    }, error => {
      console.log(error);
    });*/
    if(this.msaFileName.includes("CompanyDocument")==true)
    {
      this.msaFileDocUrl=VMSConstants.companyDocumentBaseUrl+this.msaFileName;
    }
   else{
    this.msaFileDocUrl=VMSConstants.registrationDocumentBaseUrl+this.msaFileName;
   }
    //this.msaFileDocUrl=VMSConstants.registrationDocumentBaseUrl+this.msaFileName;
  }
  
  getInsuranceFile() {
    /*this.registerService.GetInsuranceFileUrl(this.insuranceFileName).subscribe(data => {
      var blob = new Blob([data.body], { type: data.body.type });
      const reader = new FileReader();
       reader.readAsArrayBuffer(blob); 
       reader.addEventListener("load", () => {
        this.InsurancepdfSrc = reader.result;
     }, false);
  
    }, error => {
      console.log(error);
    });*/

    this.coiFileDocUrl=VMSConstants.registrationDocumentBaseUrl+this.insuranceFileName;
  }

  Showw9UploadedFile() {
    this.showPreview=true;
    // this.showW9FilePreview = false;
    // setTimeout(()=>{ 
    //   this.showW9FilePreview = true;
    // }, 5000);
    this.showW9FilePreview = false;
    console.log(this.w9FileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.w9FileDocUrl,
        title: 'W9 Form',
        fileName: this.w9FormFileName,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowDDAuthorizationUploadedFile() {
    this.showDDPreview=true;
    // this.showDDFilePreview = false;
    // setTimeout(()=>{ 
    //   this.showDDFilePreview = true;
    // }, 5000);
    this.showDDFilePreview = false;
    console.log(this.ddFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.ddFileDocUrl,
        title: 'DD Authorization',
        fileName: this.ddAuthorizationFileName,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  
  ShowMSAUploadedFile() {
    //this.showMSAPreview=true;
    // this.showMSAFilePreview = false;
    // setTimeout(()=>{ 
    //   this.showMSAFilePreview = true;
    // }, 5000);
    // this.showMSAFilePreview = false;
    // console.log(this.msaFileDocUrl);
    // const ref = this.dialogService.open(DocViewerDialogComponent, {
    //   data: {
    //     fileUrl: this.msaFileDocUrl,
    //     title: 'MSA',
    //     fileName: this.msaFileName,
    //   },
    //   width: '100%',
    //   height: '100%',
    //   baseZIndex: 10000,
    //   showHeader: false,
    // });

    this.showMSAFilePreview = false;
    console.log(this.msaFileDocUrl);
    if(this.msaDocumentFileName!= null)
    {
      if(this.msaDocumentFileName.split('.').pop() == 'gif' ||this.msaDocumentFileName.split('.').pop() == 'png' || this.msaDocumentFileName.split('.').pop() == 'jpeg' || this.msaDocumentFileName.split('.').pop() == 'jpg')
      {
        const ref = this.dialogService.open(DocViewerDialogComponent, {
          data: {
            fileUrl: this.msaFileDocUrl,
            title: 'MSA',
            fileName: this.msaDocumentFileName,
          },
          width: '100%',
          height: '100%',
          baseZIndex: 10000,
          showHeader: false,
        });
      }
      else{
        const ref = this.dialogService.open(DocViewerDialogComponent, {
          data: {
            fileUrl: this.msaFileDocUrl,
            title: 'MSA',
            fileName: this.msaFileName,
          },
          width: '100%',
          height: '100%',
          baseZIndex: 10000,
          showHeader: false,
        });
      }
    }
    else{
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.msaFileDocUrl,
          title: 'MSA',
          fileName: this.msaFileName,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
  }
  
  ShowInsuranceUploadedFile(){
     //this.showInsurancePreview=true;
     this.showInsurancePreview=true;
    //  this.showCOIFilePreview = false;
    // setTimeout(()=>{ 
    //   this.showCOIFilePreview = true;
    // }, 5000);
    this.showCOIFilePreview = false;
    console.log(this.coiFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.coiFileDocUrl,
        title: 'COI',
        fileName: this.insuranceFileName,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  @ViewChild('companysKeyCapabilitiesContainer') companysKeyCapabilitiesContainer: ElementRef;

  loadcompanysKeyCapabilities(data) {
    this.companysKeyCapabilitiesContainer.nativeElement.innerHTML = data;
  }

  @ViewChild('corporateHistoryContainer') corporateHistoryContainer: ElementRef;

  loadcorporateHistory(data) {
    this.corporateHistoryContainer.nativeElement.innerHTML = data;
  }

  @ViewChild('awardsAndCertificationsContainer') awardsAndCertificationsContainer: ElementRef;

  loadawardsAndCertifications(data) {
    this.awardsAndCertificationsContainer.nativeElement.innerHTML = data;
  }

  @ViewChild('availableCandidateBenchContainer') availableCandidateBenchContainer: ElementRef;

  loadavailableCandidateBench(data) {
    this.availableCandidateBenchContainer.nativeElement.innerHTML = data;
  }

  @ViewChild('leadershipContainer') leadershipContainer: ElementRef;

  loadleadership(data) {
    this.leadershipContainer.nativeElement.innerHTML = data;
  }

  backToPrev(){
    this.sharedService.backToPrevPage();
  }
  
  getClientNamesForView()
  {
    this.companyService.GetClientNamesView(this.adminUserProfileId).subscribe((data:any) => {
      //this.selectedClientNames=data;
      for(var i=0;i<data.length;i++)
      {
        if(this.selectedClientNames == undefined)
        {
          this.selectedClientNames = data[i].clientCompanyName;
        }
        else{
          this.selectedClientNames = this.selectedClientNames +','+ data[i].clientCompanyName;
        }
      } 
      console.log(data);
    })
  }
}
